export const ANIMAL_SEARCH_STYLE = {
  container: (provided, state) => ({
    ...provided,
    height: '100%',
    color: 'hsl(0, 0%, 90%)',
    borderRadius: '5px',
    opacity: !state.isDisabled ? '1' : '0.45',
    backgroundColor: !state.isDisabled ? 'rgba(255,255,255,0.2)' : 'rgba(255,255,255,0.4)',
    ':focus-within': {
      boxShadow: 'inset 0px 0px 0px 1.5px hsl(0, 0%, 60%)',
    },
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    display: 'none',
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: 'none',
  }),
  clearIndicator: (provided) => ({
    ...provided,
    padding: '0',
  }),
  valueContainer: (provided) => ({
    ...provided,
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexWrap: 'nowrap',
  }),
  control: (provided) => ({
    ...provided,
    backgroundColor: '#5e5e5e',
    color: 'white',
    borderColor: '#5e5e5e',
    fontSize: 12,
    height: '100%',
    minHeight: '30px',
    padding: '0',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: 'hsl(0, 0%, 90%)',
    textAlign: 'center',
    flexGrow: '1',
    lineHeight: 'initial',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: 'hsl(0, 0%, 90%)',
    lineHeight: 'initial',
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: 'transparent',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: 'white',
    lineHeight: 1,
    textAlign: 'center',
    backgroundColor: '#7e7979',
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    width: 15,
    backgroundColor: '#7e7979',
    borderColor: '#7e7979',
  }),
  input: (provided) => ({
    ...provided,
    color: 'hsl(0, 0%, 90%)',
    lineHeight: 'initial',
  }),
  menu: (provided) => ({
    ...provided,
    width: 'fit-content',
    backgroundColor: '#444645',
    zIndex: '4',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? 'rgba(255, 255, 255, 0.3)' : 'transparent',
    ':hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
    },
  }),
};
